/* ÄGAPĒ text glitch — matrix-style character scramble.
   1. Card hover: product name, price, and badge scramble then resolve.
   2. Product page load: vendor + title glitch in, description types in.
   Skipped entirely under prefers-reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var GLYPHS = 'ｱｳﾂﾚﾑﾎ01!<>-_/[]{}=+*^?#$%&';

  function randGlyph() {
    return GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
  }

  // Scramble element text over `duration` ms, resolving left→right to the
  // original. Locks the element's width so layout doesn't jitter.
  function scramble(el, duration) {
    if (!el || el.dataset.glitching) return;
    var original = el.dataset.glitchText || el.textContent;
    if (!original.trim()) return;
    el.dataset.glitchText = original;
    el.dataset.glitching = '1';
    el.style.minWidth = el.offsetWidth + 'px';
    var start = performance.now();
    function frame(now) {
      var t = Math.min((now - start) / duration, 1);
      var resolved = Math.floor(t * original.length);
      var out = original.slice(0, resolved);
      for (var i = resolved; i < original.length; i++) {
        out += original[i] === ' ' ? ' ' : randGlyph();
      }
      el.textContent = out;
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = original;
        el.style.minWidth = '';
        delete el.dataset.glitching;
      }
    }
    requestAnimationFrame(frame);
  }

  // Typewriter for longer copy (PDP description).
  function typeIn(el, speed) {
    if (!el) return;
    var original = el.textContent;
    if (!original.trim()) return;
    el.style.minHeight = el.offsetHeight + 'px';
    el.textContent = '';
    el.style.visibility = 'visible';
    var i = 0;
    var timer = setInterval(function () {
      i = Math.min(i + 3, original.length);
      el.textContent = original.slice(0, i);
      if (i >= original.length) {
        clearInterval(timer);
        el.style.minHeight = '';
      }
    }, speed);
  }

  // ---- Card hover scramble (delegated; covers re-rendered grids) ----
  document.addEventListener('mouseover', function (e) {
    var wrapper = e.target && e.target.closest && e.target.closest('.card-wrapper');
    if (!wrapper || wrapper.dataset.glitchArmed) return;
    wrapper.dataset.glitchArmed = '1';
    wrapper.addEventListener('mouseleave', function () {
      delete wrapper.dataset.glitchArmed;
    }, { once: true });
    var heading = wrapper.querySelector('.card__heading a');
    var price = wrapper.querySelector('.price-item--regular, .price-item--sale');
    var badge = wrapper.querySelector('.badge');
    scramble(heading, 420);
    scramble(price, 420);
    scramble(badge, 380);
  });

  // ---- Product page entrance ----
  function pdpEntrance() {
    var title = document.querySelector('.product__title h1');
    var vendor = document.querySelector('.product__text.caption-with-letter-spacing');
    if (!title) return;
    scramble(vendor, 400);
    scramble(title, 650);
    var desc = document.querySelector('.product__description');
    if (desc && desc.textContent.trim().length < 600) {
      setTimeout(function () {
        typeIn(desc, 16);
      }, 300);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pdpEntrance);
  } else {
    pdpEntrance();
  }
})();
